const customSelect = require('../utils/_customSelect.js');

class mFindInStore extends HTMLDivElement {
    constructor() {
        super();
        this.sizeContainer = this.querySelector('[is="m-find-in-store-sizes-filter"]');
        this.sizeError = this.sizeContainer.querySelector('.size-error');
        this.sizeSelectors = this.querySelectorAll('input[name="findinstore-sizes"]');
        this.countrySelector = this.querySelector('#findinstore-country');
        this.countryDataSelector = this.querySelector('#findinstore-country-data'); // this stores city data in pure <select> as Choices.js cannot handle it
        this.citySelector = this.querySelector('#findinstore-city');
        this.storeListContainer = this.querySelector('#findinstore-list');
        this.displayStoresUrl = this.dataset.displayStoresUrl;
        this.citySelectorPlaceholder = this.dataset.cityPlaceholder; // Default city placeholder

        // Selected values
        this.selectedPid = null;
        this.selectedCountry = this.countrySelector.value;
        this.selectedCity = null;

        // this bindings
        this.onCountryChange = this.onCountryChange.bind(this);
        this.onSizeChange = this.onSizeChange.bind(this);
        this.onCityChange = this.onCityChange.bind(this);
        this.loadStores = this.loadStores.bind(this);
    }

    connectedCallback() {
        this.countrySelector.addEventListener('change', this.onCountryChange);
        this.citySelector.addEventListener('change', this.onCityChange);
        this.sizeSelectors.forEach((input) => {
            if (input.checked) this.selectedPid = input.value;
            input.addEventListener('change', this.onSizeChange);
        });
    }

    disconnectedCallback() {
        this.countrySelector.removeEventListener('change', this.onCountryChange);
        this.citySelector.removeEventListener('change', this.onCityChange);
        this.sizeSelectors.forEach((input) => {
            input.removeEventListener('change', this.onSizeChange);
        });
    }

    onSizeChange(e) {
        this.selectedPid = e.currentTarget.value;
        if (this.selectedPid) {
            this.sizeError.classList.add('d-none');
        }
        this.loadStores();
    }

    onCountryChange() {
        const citySelectorChoiceInstance = customSelect.destroyInstanceFromId(this.citySelector.id);
        this.selectedCountry = this.countrySelector.value;
        const cityList = this.countryDataSelector.querySelector(`option[value="${this.selectedCountry}"`).dataset.cities;

        if (cityList && citySelectorChoiceInstance) {
            this.citySelector.innerHTML = '';
            this.selectedCity = null;
            const cities = JSON.parse(cityList);

            // Add placeholder
            const cityPlaceholder = document.createElement('option');
            cityPlaceholder.text = this.citySelectorPlaceholder;
            cityPlaceholder.value = '';
            cityPlaceholder.selected = true;
            cityPlaceholder.disabled = true;
            cityPlaceholder.setAttribute('aria-selected', 'false'); // Audit ARIA
            this.citySelector.appendChild(cityPlaceholder);

            // Fill the selector with the cities
            for (let i = 0; i < cities.length; i++) {
                const option = document.createElement('option');
                option.text = cities[i].name;
                option.value = cities[i].formattedName;
                option.setAttribute('aria-selected', 'false'); // Audit ARIA
                this.citySelector.appendChild(option);
            }
        }

        // re-init city selector with new content
        if (citySelectorChoiceInstance) {
            customSelect.initCustomSelect(this.citySelector.parentElement);
        }

        this.loadStores();
    }

    onCityChange(e) {
        this.selectedCity = e.currentTarget.value;
        if (!this.selectedPid) {
            this.sizeError.classList.remove('d-none');
        }
        this.loadStores();
    }

    loadStores() {
        if (this.displayStoresUrl
            && this.selectedCountry && this.selectedCountry !== ''
            && this.selectedCity && this.selectedCity !== ''
            && this.selectedPid) {
            const url = `${this.displayStoresUrl}?country=${this.selectedCountry}&city=${this.selectedCity}&pid=${this.selectedPid}`;
            this.closest('[is="o-sidebar-ajax"]').classList.add('loading', 'no-loader');

            fetch(url, {
                method: 'GET',
            }).then((response) => response.text()).then((responseData) => {
                this.storeListContainer.innerHTML = responseData;
                this.closest('[is="o-sidebar-ajax"]').classList.remove('loading', 'no-loader');
            });
        } else {
            this.storeListContainer.innerHTML = '';
        }
    }
}

customElements.define('m-find-in-store', mFindInStore, {
    extends: 'div',
});
